import Img from 'gatsby-image';
import { Link } from 'gatsby';
import React from 'react';
import { TopicSelectorStoryblok, TopicSelectorItemStoryblok } from '../../../_shared/interfaces/storyblok';
import { StoryblokCommon, getRichTextMarkup } from '../../../lib/storyblok/storyblok';
import { getMultilinkURL, isRichText } from '../../../lib/helpers/helpers';
// @ts-ignore (no types available for 'gatsby-storyblok-image')
import { getFluidGatsbyImage } from 'gatsby-storyblok-image';

import * as TopicSelectorStyles from './topic-selector.module.scss';
import * as TopicSelectorLinkStylesDr from './topic-selector-link.dr.module.scss';
import * as TopicSelectorLinkStylesHs from './topic-selector-link.hs.module.scss';

type TopicSelectorProps = {
    blok: TopicSelectorStoryblok;
    storyblokCommon: StoryblokCommon;
};

function addTopicSelectorItem(item: TopicSelectorItemStoryblok, TopicSelectorLinkStyles: { [className: string]: string }) {
    return (
        <>
            {item.image?.filename ? (
                <div className={TopicSelectorLinkStyles.iconImage}>
                    <Img fluid={getFluidGatsbyImage(item.image.filename)} alt={item.image.alt} />
                </div>
            ) : (
                <div
                    className={[
                        TopicSelectorLinkStyles.icon,
                        item.icon && TopicSelectorLinkStyles[item.icon],
                        item.icon_color && TopicSelectorLinkStyles[item.icon_color],
                    ].join(' ')}
                />
            )}

            <div style={{ color: item.title_color }}>{item.title}</div>
        </>
    );
}

const TopicSelector = (props: TopicSelectorProps) => {
    const TopicSelectorLinkStyles =
        props.storyblokCommon.configuration.content.theme === 'dr' ? TopicSelectorLinkStylesDr : TopicSelectorLinkStylesHs;

    return (
        <div className={TopicSelectorStyles.topicSelector}>
            <div
                className={[
                    TopicSelectorStyles.headline,
                    props.blok.title_orientation && TopicSelectorStyles[props.blok.title_orientation],
                ].join(' ')}
            >
                {isRichText(props.blok.richheadline) ? (
                    <div dangerouslySetInnerHTML={getRichTextMarkup(props.blok.richheadline)} />
                ) : (
                    <h3>{props.blok.title}</h3>
                )}
                <p>{props.blok.subtitle}</p>
            </div>
            <div className={TopicSelectorStyles.links}>
                {props.blok.links_list.map((item) => (
                    <div
                        className={item.background_image?.filename ? TopicSelectorLinkStyles.backgroundImage : ''}
                        key={item._uid}
                        style={
                            item.background_image?.filename
                                ? {
                                      backgroundImage: `url(${item.background_image?.filename})`,
                                  }
                                : {}
                        }
                    >
                        {item.link.linktype === 'story' ? (
                            <Link to={getMultilinkURL(item.link)} className={TopicSelectorLinkStyles.topicSelectorLink}>
                                {addTopicSelectorItem(item, TopicSelectorLinkStyles)}
                            </Link>
                        ) : (
                            <a
                                href={getMultilinkURL(item.link)}
                                target="_blank"
                                rel="noreferrer noopener"
                                className={TopicSelectorLinkStyles.topicSelectorLink}
                            >
                                {addTopicSelectorItem(item, TopicSelectorLinkStyles)}
                            </a>
                        )}
                    </div>
                ))}
            </div>
        </div>
    );
};

export default TopicSelector;
